// extracted by mini-css-extract-plugin
export default {"seal":"ReadyToIssueStamp_seal__3LRKm"};